export const lastItem     = (arr = []) => arr.length ? arr[arr.length - 1] : undefined;
export const intersection = (arrA = [], arrB = []) => arrA.filter( item => arrB.indexOf(item) > -1 );
export const keyToArray   = (events, key) => { events[key] = []; return events; };
export const unique       = (collection, item) => {
  if(collection.indexOf(item) === -1) {
    collection.push(item);
  }
  return collection;
}


// WEBPACK FOOTER //
// ./src/Services/Misc/collections.js